import React, { FunctionComponent, PropsWithChildren } from 'react'
import cn from 'classnames'
import styles from './Button.module.scss'

export type ButtonProps = {
  onClick?: () => void
  variant?: 'opacity'
  compactHover?: boolean
  className?: string
  disabled?: boolean
  type?: 'button' | 'reset' | 'submit'
  ariaLabel?: string
}
export const Button: FunctionComponent<PropsWithChildren<ButtonProps>> = ({
  onClick,
  children,
  variant,
  className,
  disabled,
  type,
  compactHover = false,
  ariaLabel,
}) => {
  return (
    <button
      className={cn(className, styles.container, {
        [styles.isOpacity]: variant === 'opacity',
        [styles.isDisabled]: disabled,
        [styles.isCompactHover]: compactHover,
      })}
      type={type}
      disabled={disabled}
      onClick={onClick}
      aria-label={ariaLabel}
    >
      <span className={styles.background}></span>
      {children}
    </button>
  )
}
